import { useQuery } from 'react-query';
import allowedCompaniesServices from './allowed-companies.services';
import { isAppPortocar } from '@/index';

export const QUERY_WOM_ALLOWED_COMPANIES = 'wom/allowed-companies/exists';

export function useWOMAllowedCompaniesExists(companyId?: number) {
  return useQuery({
    queryKey: [QUERY_WOM_ALLOWED_COMPANIES, { companyId }],
    queryFn: () => allowedCompaniesServices.exists(companyId),
    enabled: !!companyId && !isAppPortocar,
  });
}

export function useHasWomPermission(companyId?: number) {
  const allowedCompanies = useWOMAllowedCompaniesExists(companyId);
  return allowedCompanies.data?.exists || false;
}
